import React, { FC } from 'react'

import cn from 'classnames'

import MobileMenuGroupItem from './mobile-menu-group-item'
import {
  getLoggedInMobileMenuItems,
  getLoggedOutMobileMenuItems,
} from './MobileMenu.content'
import classes from './MobileMenu.module.scss'
import { MobileMenuProps } from './MobileMenu.types'
// import { useAppDispatch } from '../../../../store'
// import { logoutUser } from '../../../../store/auth/dispatchers/logoutUser'
import MenuItemCommon from '../menu-item'

const MobileMenu: FC<MobileMenuProps> = ({
  isOpen,
  isAuthenticated,
  isAbandonedAccount,
  isActivated,
  isNotInGroup,
  userHasUsage,
  userHasAgreement,
  memberWithNickname,
  marketingUrl,
  communityUrl,
  logoutUser,
}) => {
  // const dispatch = useAppDispatch()

  const logOut = () => logoutUser()

  const menuItems = isAuthenticated
    ? getLoggedInMobileMenuItems({
        isAbandonedAccount,
        isActivated,
        isNotInGroup,
        userHasUsage,
        userHasAgreement,
        memberWithNickname,
        logOut,
      })
    : getLoggedOutMobileMenuItems({ marketingUrl, communityUrl })

  return (
    <div className={cn(classes.menu, isOpen ? classes.open : classes.closed)}>
      <ul className={classes.inner}>
        {menuItems.map((menuItem) => (
          <li key={menuItem.id} tabIndex={0} className={classes.menuItem}>
            {menuItem.items ? (
              <MobileMenuGroupItem menuItem={menuItem} />
            ) : (
              <MenuItemCommon
                menuItem={menuItem}
                className={classes.menuItem}
              />
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default MobileMenu
